import React from 'react';
import { BannerGroupMapper, BannerRC, ChipsBlockRC, Container, ElkBlock, ElkCard, Empty, Error, FooterButtonRC, HeaderSearchRC, HistoryBlock, OtherBlock, OtherCard, ProductBlock, ProductCard, RecommendationBlock, RecommendationCard, ScrollableWrapper, SearchInput, Section, ServiceBlock, ServiceCard, SkeletonLayoutRC, TariffBlock, TariffCard } from "./blocks";
export var Search = function Search(_ref) {
  var className = _ref.className,
    isDesktop = _ref.isDesktop;
  return /*#__PURE__*/React.createElement(Container, {
    className: className,
    "data-t-id": "components-Search"
  }, /*#__PURE__*/React.createElement(Section, {
    "data-t-id": "components-Search"
  }, /*#__PURE__*/React.createElement(HeaderSearchRC, {
    shouldRender: isDesktop,
    "data-t-id": "components-Search"
  }), /*#__PURE__*/React.createElement(SearchInput, null), /*#__PURE__*/React.createElement(ChipsBlockRC, null)), /*#__PURE__*/React.createElement(SkeletonLayoutRC, null, /*#__PURE__*/React.createElement(ScrollableWrapper, {
    "data-t-id": "components-Search"
  }, /*#__PURE__*/React.createElement(HistoryBlock, {
    "data-t-id": "components-Search"
  }), /*#__PURE__*/React.createElement(RecommendationBlock, {
    shouldRender: isDesktop
  }, /*#__PURE__*/React.createElement(RecommendationCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(ElkBlock, null, /*#__PURE__*/React.createElement(ElkCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(TariffBlock, null, /*#__PURE__*/React.createElement(TariffCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(ProductBlock, null, /*#__PURE__*/React.createElement(ProductCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(ServiceBlock, null, /*#__PURE__*/React.createElement(ServiceCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(OtherBlock, null, /*#__PURE__*/React.createElement(OtherCard, {
    "data-t-id": "components-Search"
  })), /*#__PURE__*/React.createElement(Error, null), /*#__PURE__*/React.createElement(Empty, null)), /*#__PURE__*/React.createElement(Section, {
    isBottomFixed: true
  }, /*#__PURE__*/React.createElement(FooterButtonRC, {
    "data-t-id": "components-Search"
  }), /*#__PURE__*/React.createElement(BannerGroupMapper, {
    shouldRender: isDesktop
  }, /*#__PURE__*/React.createElement(BannerRC, {
    "data-t-id": "components-Search"
  })))));
};